import clsx from 'classnames'
import { forwardRef, HTMLProps } from 'react'
import { MediaAboutSkeletonCard } from '@/entities/media-about-card'
import style from './media-about-list.module.scss'

interface MediaAboutLoaderProps extends HTMLProps<HTMLUListElement> {}

export const MediaAboutLoader = forwardRef<HTMLUListElement, MediaAboutLoaderProps>(({ className }, ref) => {
  return (
    <>
      {[4, 3, 2, 1].map((_, index) => (
        <MediaAboutSkeletonCard className={className} key={index} index={index} />
      ))}
    </>
  )
})

MediaAboutLoader.displayName = 'MediaAboutLoader'
